import React, { useState } from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import TableDividerPlusBar from "@FillInTableContainer/shared/components/TableDividerPlusBar/TableDividerPlusBar";
import { useGetInfoOfShell } from "@FillInTableContainer/shared/hooks/useGetInfoOfShell";
import { getTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";

import { DEAL_LA_SC_PARTNER_AXIS_TABLE_LAYOUT } from "../../../../constants/dealLaScDealTermsGroupTableLayout";
import DealLaScFinancialTermsGroupTable from "../../../DealLaScFinancialTermsGroupTable/DealLaScFinancialTermsGroupTable";

type Props = {
  groupTableIndex: number;
  groupTableKey: DealLaScSection;
};
const partnerAxisTableList = DEAL_LA_SC_PARTNER_AXIS_TABLE_LAYOUT;
const DealLaScPartnerAxisGroupTable = ({
  groupTableIndex,
  groupTableKey,
}: Props) => {
  const articleSection = ENTRY_DATA_SECTION_KEYS.dealsLaSc;
  const { shellValue } = useGetInfoOfShell(groupTableKey, articleSection);
  const initialDisplayAxisCTable = !!(
    shellValue("Partner C Name", 0, 0, 0).value.length > 0 ||
    shellValue("Partner C Relationship Context", 0, 0, 0).value.length > 0 ||
    shellValue("Partner C Responsibility & Rights", 0, 0, 0).value.length > 0
  );
  const [displayAxisCTable, setDisplayAxisCTable] = useState(
    initialDisplayAxisCTable,
  );

  const tableListWithoutPartnerCTable = partnerAxisTableList.filter(
    ({ tableKey }) => tableKey !== "Partner C Axis",
  );

  const tableList = displayAxisCTable
    ? partnerAxisTableList
    : tableListWithoutPartnerCTable;

  const customTableDeleteEvent = () => {
    setDisplayAxisCTable(false);
  };
  const handleAddTable = () => {
    setDisplayAxisCTable(true);
  };

  return (
    <>
      <DealLaScFinancialTermsGroupTable
        tableList={tableList}
        groupTableKey={groupTableKey}
        groupTableIndex={groupTableIndex}
        customTableDeleteEvent={customTableDeleteEvent}
      />
      {!displayAxisCTable && (
        <TableDividerPlusBar
          tableTitle={getTableTitle(articleSection, "Partner C Axis") || ""}
          isLastPosition={false}
          isEndText={false}
          onClick={() => handleAddTable()}
          isVisibility
        />
      )}
    </>
  );
};

export default DealLaScPartnerAxisGroupTable;
